export default {
  selectFile: {
    id: 'bo_seller.kyb.input_file_upload.select_file',
    defaultMessage: 'Select file',
  },
}
